import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Component, Injector, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { T2CardComponent } from '../../trip2-theme/components/t2-card/t2-card.component';
import { GridOptions, GridReadyEvent, GridSizeChangedEvent } from 'ag-grid';
import { OnDemandDriversService } from './on-demand-drivers.service';
import { BooleanCheckComponent } from '../A2-utils/grid-components/boolean-check/boolean-check.component';
import { SendMessageComponent, SendMessageI } from 'app/utils/send-message/components/send-message/send-message.component';
import { ToastrAlertHelper } from 'app/core/helpers/toastr-alert-helper-service';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';
import { Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { getSelectNodeAfterFilter } from 'app/utils/helpers';
import { IApiResponse } from 'app/core/interfaces/invoice-external.interface';
import { ParentModule } from '../A2-utils/ParentClass/parent-module';
import { DriverBackgroundCheckStateService } from '../../utils/driver-background-check/driver-background-check-state.service';

interface OnDemandDriverRowClickEvent {
  data?: {
    userprofileid: number;
    fullname: string;
  };
  column?: {
    colDef?: {
      colId?: string;
    };
  };
}

interface OnDemandDriverCancelEvent {
  type?: string;
}

@Component({
  selector: 'app-on-demand-drivers',
  templateUrl: './on-demand-drivers.component.html',
  styleUrls: ['./on-demand-drivers.component.scss'],
  providers: [DriverBackgroundCheckStateService]
})

export class OnDemandDriversComponent extends ParentModule implements OnInit, OnDestroy {

  @ViewChild('messageModal') modal: T2CardComponent;
  @ViewChild('SendMessageComponent') hijo: SendMessageComponent;
  @Input('ProviderId') ProviderId?: number;
  @ViewChild('modalDriverOndeman') modalDriverOndeman: T2CardComponent;

  activeAdd = false;
  isFormExpanded = false;
  enabledBtn = false;
  driverSelected = 0;
  nameSelected = '';
  driverName = '';
  selectedDrivers: any[] = [];
  selectedStatus = 33;
  rejectionstatusid = undefined;
  status: any[];
  rejecetedReasonList: any[];
  counter = 0;

  // Grid
  driverGrid: GridOptions;
  protected data: any;

  protected noFilterData: any;

  // serch
  protected filter = '';
  protected showDisabled = false;

  protected showLoading = false;
  btnMessageDisabled: boolean;

  protected typeMessage = {
    email: true,
    phone: false,
    title: 'Send Message'
  };
  protected message = '';
  protected PlainMessage = '';
  protected subject = '';

  isOpenModalSendMessage = false;

  searchGridForm;

  optionsConfig: SendMessageI;
  formSendMessage: FormGroup;

  get emailCtrl(): AbstractControl { return this.formSendMessage.get('email') }
  get phoneCtrl(): AbstractControl { return this.formSendMessage.get('phone') }
  get messageCtrl(): AbstractControl { return this.formSendMessage.get('message') }

  get isEmbeddedInProvider(): boolean {
    return typeof this.ProviderId === 'number' && !isNaN(this.ProviderId);
  }

  get moduleClass(): { [key: string]: boolean } {
    return { 'layout-form-expanded': this.isFormFullscreen };
  }

  get isFormFullscreen(): boolean {
    return this.isFormExpanded && this.activeAdd && !this.isEmbeddedInProvider;
  }

  actionSendDriverVideo = false;
  subscriptions: Subscription[] = [];

  constructor(
    private toastrAlertHelper: ToastrAlertHelper,
    private onDemandDriversService: OnDemandDriversService,
    private fb: FormBuilder,
    private sweetAlertHelper: SweetAlertHelper,
    private driverBackgroundCheckService: DriverBackgroundCheckStateService,
    protected Inject: Injector,
  ) {
    super('ondemand-drivers', Inject);
    this.getAllStatus();
    this.callServiceWithFilter();
    this.defineColumnsGrid();
    this.initForm();
    this.optionsConfigSendMessage();
  }

  ngOnInit() {
    this.actionsList$.subscribe(() => {
      this.actionSendDriverVideo = this.isAllowedAction('SendDriverVideo');
    });
    this.subscriptions.push(
      this.onDemandDriversService.formExpanded$.subscribe((expanded: boolean) => {
        this.onToggleExpandForm(expanded);
      })
    );
  }

  initForm() {
    this.formSendMessage = this.fb.group({
      email: [true],
      phone: [false],
      subject: ['', Validators.required],
      message: ['', Validators.required],
    });
  }

  optionsConfigSendMessage(): void {
    this.optionsConfig = {
      modal: true,
      draggable: false,
      title: this.typeMessage.title,
      grid: this.driverGrid
    }
  }

  /**
   * @name defineColumnsGrid
   * @description Definir la columnas de la grilla
   */
  defineColumnsGrid() {
    this.driverGrid = <GridOptions>{
      enableColResize: true,
      enableSorting: true,
      enableFilter: true,
      columnDefs: [
        {
          colId: 'id',
          width: 30,
          checkboxSelection: true,
          headerCheckboxSelection: true,
        },
        {
          headerName: 'ID',
          field: 'userprofileid',
          colId: 'userprofileid',
          width: 60
        },
        {
          headerName: 'Name',
          field: 'fullname',
          colId: 'fullname',
          width: 200
        },
        {
          headerName: 'Phone',
          field: 'phone',
          colId: 'phone',
          width: 200,
        },
        {
          headerName: 'Email',
          field: 'emailaddress',
          colId: 'email',
          width: 150,
        },
        {
          headerName: 'Active',
          field: 'isactive',
          cellRendererFramework: BooleanCheckComponent,
          colId: 'isactive',
          width: 50,
        },
        {
          headerName: 'Lic. Status',
          field: 'driverlicensestatus',
          width: 100,
        },
        {
          headerName: 'Lic',
          field: 'documentstatus.description',
          colId: 'documentstatus',
          width: 50,
        },
        {
          headerName: 'Application Date',
          field: 'applicationdate',
          colId: 'applicationdate',
          width: 100,
        }
      ],
      onGridReady: (event: GridReadyEvent) => {
        this.driverGrid.api.sizeColumnsToFit();
        this.driverGrid.rowSelection = 'multiple';
      },
      onGridSizeChanged: (event: GridSizeChangedEvent) => {
        if (event && event.api) {
          event.api.sizeColumnsToFit();
        }
      },
      onSelectionChanged: () => {
        if (this.driverGrid && this.driverGrid.api) {
          this.selectedDrivers = this.driverGrid.api.getSelectedRows();
        }
      },
      onRowSelected: (event: any) => {
        this.getSelectedDrivers();
      },
      onFilterChanged: (ev: any) => {
        this.selectedDrivers = [];
      }
    };
  }

  /**
   * @name callService
   * @description
   */
  callService() {
    this.onDemandDriversService
    .getDrivers()
    .subscribe(
      data => {
        this.noFilterData = data;
        this.loadData(data);
      }
    );
  }

  /**
   * @name loadData
   * @description
   * @param {any[]} data
   */
  loadData(data: any[]) {
    this.data = data;
    if (data !== null) {
      this.counter = this.data.length;
      if (this.driverGrid) {
        if (this.driverGrid.api) {
          const filter = this.driverGrid.api.getFilterModel();
          this.driverGrid.api.setRowData(data);
          this.driverGrid.api.setFilterModel(filter);
        }
      }
    }
  }

  /**
   * @name getSelectedDrivers
   * @description
   */
  private getSelectedDrivers() {
    const users = [];
    let swt = false;
    this.driverGrid.api.forEachNodeAfterFilter( (data: any) => {
      if(data['selected']){
        swt = true;
        this.btnDisabledTab(swt);
      }
      users.push(data.data.userprofileid);
    });
    this.btnDisabledTab(swt);
    return users;
  }

  btnDisabledTab(disabled: boolean) {
    this.enabledBtn = disabled;
    this.btnMessageDisabled = disabled;
  }

  /**
   * @name showMessageModuleNew
   * @description Method for send message
   * @param driverGrid type GridOptions.
   */
  showMessageModuleNew(): void {
    this.selectedDrivers = [];
    this.hijo.showMessageModule(this.driverGrid, this.selectedDrivers);  //:TODO: METODO DEL HIJO.
  }

  /**
   * @name setSelected
   * @description
   * @param event
   */
  setSelected(event: OnDemandDriverRowClickEvent) {
    if (!event.data) {
      return;
    }
    this.driverSelected = event.data.userprofileid;
    this.driverName = event.data.fullname;
    this.driverBackgroundCheckService.setDriverId(this.driverSelected);
  }

  /**
   * @name changeActiveAdd
   * @description description
   */
  changeActiveAdd($event?: OnDemandDriverCancelEvent | boolean) {
    if (this.isEmbeddedInProvider) {
      this.modalDriverOndeman.isOpen ? this.modalDriverOndeman.close() : this.modalDriverOndeman.open();
    } else if (!$event || typeof $event === 'boolean' || $event.type !== 'cancel') {
      this.activeAdd = !this.activeAdd;
      if (this.activeAdd && !this.isEmbeddedInProvider) {
        this.onDemandDriversService.setFormExpanded(true);
      } else if (!this.activeAdd) {
        this.onDemandDriversService.setFormExpanded(false);
      }
      if (!this.nameSelected) {
        this.enabledBtn = false;
      }
      this.btnMessageDisabled = true;
    }
  }

  /**
   * @name onNotify
   * @description
   * @param resp
   */
  onNotify(resp: any): void {
    this._loading.show();
    if (resp && resp.success) {
      this.swalResponse('success', resp.title || '', resp);
      this.btnDisabledTab(false);
      this.search();
    } else {
      if (resp && resp.modelstate) {
        const error = [];
        Object.keys(resp.modelstate).forEach((key, i) => error.push(resp.modelstate[key][i]));
        this.swalResponse('error', 'Error', resp, error);
      } else {
        this.swalResponse('error', 'Error', resp);
      }
    }

    if (resp && resp.error) {
      this.toastrAlertHelper.error(resp.error);
    }
  }

  swalResponse(type: any, title: any, text: any, array?: any) {
    this.sweetAlertHelper.createCustomAlert({
      type: type,
      title: title,
      text: text.modelstate ? array.filter((item) => item) : text.message
    }).then(() => {
      this._loading.hiden();
    });
  }

private onToggleExpandForm(expanded: boolean): void {
  this.isFormExpanded = expanded;

  if (!expanded && this.driverGrid && this.driverGrid.api) {
    requestAnimationFrame(() => {
      this.driverGrid.api.doLayout();
      this.driverGrid.api.sizeColumnsToFit();
    });
  }
}

private isGridSelectionColumn(event: OnDemandDriverRowClickEvent): boolean {
  return !!(event.column && event.column.colDef && event.column.colDef.colId === 'id');
}

onRowClick(event: OnDemandDriverRowClickEvent): void {
  if (!event || !event.data || this.isGridSelectionColumn(event)) {
    return;
  }

  this.setSelected(event);
  this.nameSelected = this.driverName;

  if (this.isEmbeddedInProvider) {
    if (this.modalDriverOndeman && !this.modalDriverOndeman.isOpen) {
      this.changeActiveAdd();
    }
    return;
  }

  if (!this.activeAdd) {
    this.activeAdd = true;
  }

  this.onDemandDriversService.setFormExpanded(true);
}

  onRowDoubleClick(event: OnDemandDriverRowClickEvent): void {
    this.onRowClick(event);
  }

  /**
   * @name edit
   * @description
   */
  edit(event: any) {
    if (this.driverSelected === 0) {
      this.showWarningMessage('Select a record');
    } else {
      this.nameSelected = this.driverName;
      this.changeActiveAdd();
    }
  }

  /**
   * @name showWarningMessage
   * @description
   * @param message
   */
  showWarningMessage(message) {
    this.toastrAlertHelper.warning(message);
  }

  /**
   * @name onPress
   * @description Search
   */
  public onPress(event) {
    this.filter = event;
  }

  /**
   * @name search
   * @description
   */
  public search(): void {
    this.callServiceWithFilter();
  }

  /**
   * @name callServiceWithFilter
   * @description
   */
  public callServiceWithFilter() {
    this.showLoading = true;
    this.onDemandDriversService
    .getFilterDriver(this.filter, this.showDisabled,
                     this.selectedStatus, this.rejectionstatusid)
    .subscribe(
      data => {
        this.loadData(data);
        this.showLoading = false;
      }
    );
  }

  /**
   * @name showDisable
   * @description
   * @param event
   */
  public showDisable(event) {
    this.showDisabled = event.target.checked;
    this.callServiceWithFilter();
  }

  /**
   * @name onChange
   * @description cuando cambia el estado
   */
  public onChange(): void {
    if (this.selectedStatus !== 34) { this.rejectionstatusid = undefined; }
    this.callServiceWithFilter();
    this.getRejectedReasonList();
  }

  /**
   * @name getAllStatus
   * @description optiene todos los estados para on demand driver y aplicants
   */
  private getAllStatus() {
    this.onDemandDriversService
    .getAllStatus()
    .subscribe(
      data => { this.status = data; }
    );
  }

  /**
   * @name onKeyPress
   * @description
   * @param event
   */
  public onKeyPress(event) {
    if (event.key === 'Enter') {
      this.search();
    }
  }

  getRejectedReasonList(): void {
    switch (this.selectedStatus) {
      case 34:
        this.onDemandDriversService.getRejectedReason().subscribe(
          data => this.rejecetedReasonList = data
        );
        break;
      default:
        break;
    }
  }

  verifyLicenseMassive(): void {
    if (!this.selectedDrivers || !this.selectedDrivers.length) {
      this.sweetAlertHelper.createCustomAlert({
        title: 'You must select at least one driver.',
        type: 'warning',
      });
      return;
    }
    this.sweetAlertHelper
      .createCustomAlert({
        title: 'Driver License Verification',
        text: `This action will verify the status of the driver's license with an external service (Fees may apply).
          If the license is invalid, the driver's status will be set to Suspended automatically. Do you want to continue?`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
      })
      .then((result) => {
        if (result.value) {
          this.driverVerifyLicenseMassive();
        }
      });
  }

  private driverVerifyLicenseMassive(): void {
    const driversSelected = getSelectNodeAfterFilter(this.driverGrid);
    const payload = driversSelected.map((driver) => driver.userprofileid);
    if (!payload || !payload.length) {
      return;
    }
    this._loading.show();
    this.subscriptions.push(
      this.onDemandDriversService
        .verifyDriverLicenseMassive(payload)
        .pipe(finalize(() => this._loading.hiden()))
        .subscribe({
          next: (res: IApiResponse) => {
            this.sweetAlertHelper.createCustomAlert({
              title: res.message,
              type: 'success',
            });
            this.callServiceWithFilter();
          },
          error: (err) => {
            this.sweetAlertHelper.captureException(err);
          },
        })
    );
  }

  sendVideoDriver() {
    const selectedDrivers = getSelectNodeAfterFilter(this.driverGrid);
    if (selectedDrivers.length && this.actionSendDriverVideo) {
      this.sweetAlertHelper
        .createCustomAlert({
          type: 'warning',
          title: 'Send Video',
          text: 'Are you sure you want to send the video to the selected drivers?',
          showCancelButton: true,
          confirmButtonText: 'Yes, send it!',
          cancelButtonText: 'No, cancel!',
        })
        .then((result) => {
          if (result.value) {
            const driverid = {
              driverid: selectedDrivers.map((item) => item.userprofileid),
            };
            this.subscriptions.push(
              this.onDemandDriversService.sendVideoDriver(driverid).subscribe(
                (resp: any) => {
                  if (resp) {
                    this.sweetAlertHelper.createCustomAlert({
                      title: 'Success',
                      text: resp.message,
                      type: 'success',
                    });
                  }
                },
                (error) => {
                  this.sweetAlertHelper.createCustomAlert({
                    title: 'Error',
                    text: error.message,
                    type: 'error',
                  });
                }
              )
            );
          }
        });
    } else {
      this.sweetAlertHelper.createCustomAlert({
        title: 'Error',
        text: 'You do not have permissions to perform this action',
        type: 'error',
      });
    }
  }

  ngOnDestroy() {
    if (this.subscriptions && this.subscriptions.length) {
      this.subscriptions.forEach((subscription: Subscription) => {
        if (subscription) {
          subscription.unsubscribe();
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/on-demand-drivers/on-demand-drivers.component.ts